// import * as Yup from 'yup';
import React, { useEffect, forwardRef } from 'react';
import { Grid, TextField, Button, Input, MenuItem } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik, Form, Field } from 'formik';
import Iconify from '../../components/Iconify';
import FormAction from '../../components/FormAction';

// const validationSchema = Yup.object({
//   current_password: Yup.string().required('Current password is required'),
//   new_password: Yup.string().required('New password is required'),
//   confirm_new_password: Yup.string().oneOf([Yup.ref('new_password'), null], 'Confirm new password not matched').required('Confirm new password is required'),

// });

function ChangePasswordForm({ formValues, handleChangePassword, resetFormValues, closePopup }, ref) {
  return (
    <Formik
      initialValues={formValues}
     // validationSchema={validationSchema }
      onSubmit={handleChangePassword}
      enableReinitialize
      innerRef={ref}
    >
      {(formikHelper) => {
        return (
          <Form autoComplete="off" style={{ marginTop: '12px' }}>
            <Grid container spacing={3}>
              
            <Grid item xs={12} md={6}>
                <Field
                  as={TextField}
                  fullWidth
                  autoComplete="current_password"
                  name="current_password"
                  size="small"
                  label="Current Password*"
                  error={formikHelper.touched.current_password && Boolean(formikHelper.errors.current_password)}
                  helperText={formikHelper.touched.current_password && formikHelper.errors.current_password}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  as={TextField}
                  fullWidth
                  autoComplete="new_password"
                  name="new_password"
                  size="small"
                  label="New Password*"
                  error={formikHelper.touched.new_password && Boolean(formikHelper.errors.new_password)}
                  helperText={formikHelper.touched.new_password && formikHelper.errors.new_password}
                />
              </Grid>
             <Grid item xs={12} md={6}>
                <Field
                  as={TextField}
                  fullWidth
                  autoComplete="confirm_new_password"
                  name="confirm_new_password"
                  size="small"
                  label="Confirm New Password*"
                  error={formikHelper.touched.confirm_new_password && Boolean(formikHelper.errors.confirm_new_password)}
                  helperText={formikHelper.touched.confirm_new_password && formikHelper.errors.confirm_new_password}
                />
              </Grid>
             

              <FormAction>
                <LoadingButton
                  type="submit"
                  color="secondary"
                  disabled={!formikHelper.isValid}
                  loading={formikHelper.isSubmitting}
                  variant="contained"
                >
                  {'Submit'}
                </LoadingButton>
                <Button onClick={()=>closePopup(false)} variant="contained" color="inherit">
                  Close
                </Button>
              </FormAction>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}

export default forwardRef(ChangePasswordForm);
